import type { Feature } from "../../api/features.service";
import { featureSchema } from "../../schemas/featureSchema";
import { buildColumnsFromSchema, buildModalFieldsFromSchema } from "../../schemas/schemaHelpers";
import type { DetailFieldGroup } from "../../components/DetailModal/DetailModal";

export type SortField = "code" | "name" | "type" | "scope" | "entity_id_field" | "status";

// Fields to show in table and modal
const TABLE_FIELDS: (keyof Feature)[] = [
  "code",
  "name",
  "description",
  "type",
  "scope",
  "entity_id_field",
  "available_page_types",
  "available_sites",
  "available_languages",
  "status",
];

export const COLUMN_CONFIGS = buildColumnsFromSchema(featureSchema, TABLE_FIELDS);

// Grouped fields for modal
export const MODAL_FIELD_GROUPS: DetailFieldGroup<Feature>[] = [
  {
    heading: "Basic Information",
    fields: buildModalFieldsFromSchema(featureSchema, ["code", "name", "description", "status"]),
  },
  {
    heading: "Feature Type & Scope",
    fields: buildModalFieldsFromSchema(featureSchema, ["type", "scope", "entity_id_field"]),
  },
  {
    heading: "Availability",
    fields: buildModalFieldsFromSchema(featureSchema, [
      "available_page_types",
      "available_sites",
      "available_languages",
    ]),
  },
];

export const FILTER_OPTIONS = {
  type: [
    { value: "all", label: "All Types" },
    { value: "content", label: "Content" },
    { value: "user", label: "User" },
  ],
  scope: [
    { value: "all", label: "All Scopes" },
    { value: "firm", label: "Firm" },
    { value: "contact", label: "Contact" },
    { value: "office", label: "Office" },
    { value: "null", label: "None" },
  ],
  status: [
    { value: "all", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "deprecated", label: "Deprecated" },
  ],
};

export const FILTER_CONFIGS = [
  { key: "type", label: "Type", options: FILTER_OPTIONS.type },
  { key: "scope", label: "Scope", options: FILTER_OPTIONS.scope },
  { key: "status", label: "Status", options: FILTER_OPTIONS.status },
];
